const messages = {
  filters: ['Filters', 'Фильтры'],
  acquisitionSourceContactFilter: ['Acquisition source (UTM)', 'Источник привлечения (UTM)'],
  add: ['Add filter', 'Добавить фильтр'],
  field: ['Column / field', 'Колонка / поле'],
  operation: ['Operation', 'Операция'],
  value: ['Value', 'Значение'],
  from: ['From (inclusive)', 'От (включительно)'],
  to: ['To (inclusive)', 'До (включительно)'],
  apply: ['Apply', 'Применить'],
  cancel: ['Cancel', 'Отмена'],
  remove: ['Remove filter', 'Удалить условие'],
  reset: ['Clear all filters', 'Сбросить все фильтры'],
  in: ['Is any of', 'Любое из'],
  not_in: ['Is none of', 'Ни одно из'],
  contains: ['Contains', 'Содержит'],
  not_contains: ['Does not contain', 'Не содержит'],
  between: ['Between (inclusive)', 'В диапазоне (включительно)'],
  not_between: ['Outside range', 'Вне диапазона'],
  eq: ['Equals', 'Равно'],
  gte: ['Greater than or equal to', 'Больше или равно'],
  lte: ['Less than or equal to', 'Меньше или равно'],
  on: ['On date', 'В указанную дату'],
  before: ['Before date', 'Раньше даты'],
  after: ['After date', 'Позже даты'],
  error: ['Could not complete the request. Please try again.', 'Не удалось выполнить запрос. Повторите попытку.'],
  totalsError: ['Could not load contact totals.', 'Не удалось загрузить итоговые суммы контактов.'],
  invalid: [
    'Enter valid values; the start must not exceed the end.',
    'Заполните значения: начало диапазона не должно превышать конец.',
  ],
  loading: ['Loading filters…', 'Загрузка фильтров…'],
  retry: ['Retry', 'Повторить'],
  all: [
    'All conditions must match. Within a selection, any value may match.',
    'Все условия применяются вместе. Внутри списка достаточно одного значения.',
  ],
  search: ['Search contacts', 'Поиск контактов'],
  searchChoices: ['Find a value', 'Найти значение'],
  noChoices: ['No values available', 'Нет доступных значений'],
  nameContactFilter: ['Name', 'Имя'],
  activityContactFilter: ['Last seen', 'Последняя активность'],
  depositAmountSumContactFilter: ['In (USD)', 'Ввод (USD)'],
  withdrawalAmountContactFilter: ['Out (USD)', 'Вывод (USD)'],
  netAmountContactFilter: ['In − Out (USD)', 'Ввод − вывод (USD)'],
  lastCommentContactFilter: ['Latest task comment', 'Комментарий последней задачи'],
  lastNoteContactFilter: ['Latest note text', 'Текст последней заметки'],
  tagContactFilter: ['Tags', 'Теги'],
  salesStatusContactFilter: ['Sales status', 'Статус продаж'],
  managerUserFilter: ['Manager', 'Менеджер'],
  managerGroupUserFilter: ['Manager group', 'Группа менеджеров'],
  ibManagerUserFilter: ['IB manager', 'IB-менеджер'],
  brandContactFilter: ['Brand', 'Бренд'],
  registrationContactFilter: ['Registration date', 'Дата регистрации'],
  creationDateContactFilter: ['Contact created', 'Дата создания контакта'],
  addressCountryContactFilter: ['Country', 'Страна'],
  emailConfirmContactFilter: ['Email confirmed', 'Email подтверждён'],
  kycStatusContactFilter: ['Verification status', 'Статус верификации'],
  walletBalanceSumContactFilter: ['Wallet balance (USD)', 'Баланс кошелька (USD)'],
  clientTypeContactFilter: ['Client type', 'Тип клиента'],
  firstDepositDateContactFilter: ['First deposit date', 'Дата первого депозита'],
  accountTypeContactFilter: ['Account type', 'Тип счёта'],
  partnerCodeContactFilter: ['Partner code', 'Партнёрский код'],
  currentStatusContactFilter: ['Client status', 'Статус клиента'],
};

export const filterText = (intl, key) => {
  const message = messages[key];
  return message ? message[intl.locale?.startsWith('ru') ? 1 : 0] : intl.formatMessage({ id: key });
};

export const columnFilters = {
  justName: 'nameContactFilter',
  justLastSeen: 'activityContactFilter',
  justIn: 'depositAmountSumContactFilter',
  justOut: 'withdrawalAmountContactFilter',
  justInAndOut: 'netAmountContactFilter',
  crmSalesStatus: 'salesStatusContactFilter',
  justTags: 'tagContactFilter',
  justLastComment: 'lastCommentContactFilter',
  lastNoteText: 'lastNoteContactFilter',
};
